
import { Component, Vue } from 'vue-property-decorator';

import AppHeader from '@/shared/components/AppHeader.vue';
import LeftMenu from '@/shared/components/LeftMenu.vue';
import Breadcrumb from '@/shared/components/Breadcrumb.vue';

import authService from '@/services/auth-services';
import { APP_CONFIG } from '@/config/app-config';
import commonService from '@/services/common-services';
import AppEvents from '@/event.js';
import { eventBus } from '@/main';

@Component({
  components: {
    AppHeader,
    LeftMenu,
    'bread-crumb': Breadcrumb
  },
})
export default class App extends Vue {
  disableMenuLeft = true;
  disableHeader = true;

  get showMenu() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
  }

  get rate() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
  }

  private async getRate() {
    const result = await commonService.exchangeRate();
    if (result && result.status === 200) {
      (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
      (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
    }
  }

  private async getConfiguration() {
    const result = await commonService.configuration();
    if (result && result.status === 200) {
      (window['getApp'] as any).$emit('SET_CONFIGURATION', result.data.data);
    }
  }

  private beforeCreate() {
    AppEvents.forEach((item) => {
        this.$on(item.name, item.callback);
      });
    window['getApp'] = this;
  }

  private async created() {
    eventBus.$on(APP_CONFIG.eventBusAction.disableMenuLeft, (data) => {
      this.disableMenuLeft = data;
    });

    eventBus.$on(APP_CONFIG.eventBusAction.disableHeader, (data) => {
      this.disableHeader = data;
    });

    if (!this.rate) {
      await this.getRate();
    }

    await this.getConfiguration();
  }

  private onClickMask() {
    (window['getApp'] as any).$emit('SHOW_HIDE_MENU_LEFT', false);
  }
}
